// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "922020e1d19d53d5a6d434ce3f1926cf" + ".js";
};